import { type BreakpointsProps } from '@/types';
import { styled } from '@volkswagen-onehub/components-core';
import {
  convertBreakpointsToMediaQueries,
  jssToCss,
  tokens,
} from '@/modules/utils/themeUtils';
import zIndex from '@/modules/constants/zIndex';

interface StyledCardProps extends BreakpointsProps<StyledCardProps> {
  width?: string;
  height?: string;
  hasMask: boolean;
}

interface StyledInactiveProps {
  hasDecoratorImg?: boolean;
}

export const StyledCard = styled.div<StyledCardProps>(
  ({ hasMask, height, width, theme, ...restProps }) => {
    return `
      ${hasMask && `padding-top: ${theme.size.static370};`};

      ${jssToCss({
        width,
        height,
      })};

      ${convertBreakpointsToMediaQueries(restProps)};
    `;
  }
);

export const StyledCardInner = styled.div(({ theme }) => {
  return `
      height: 100%;
      background-color: ${tokens(theme).globalColors.vLightBeige};
      border-radius: ${theme.size.static350};
      padding: ${theme.size.static370};
      position: relative;
      display: flex;
      flex-direction: column;

    `;
});

export const StyledBody = styled.div(
  ({ theme }) => `
  flex-grow: 1;
  margin-bottom: ${theme.size.static250};
`
);

export const StyledDecoratorImg = styled.div(
  ({ theme }) => `
  margin-left: 50%;
  width: max-content;
  transform: translateX(-50%);
  margin-top: calc(${theme.size.static370} * -2);
  margin-bottom: ${theme.size.static370};
`
);

export const StyledInactive = styled.div<StyledInactiveProps>(
  ({ hasDecoratorImg, theme }) => `
  position: absolute;
  top: ${hasDecoratorImg ? `calc(${theme.size.static370} * -2)` : '0'};
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${zIndex.FOREGROUND};
  background: rgba(255,255,255,0.8);
`
);

export const StyledHeader = styled.div(
  ({ theme }) => `
  font-size: ${theme.size.static300}};
  margin-bottom: ${theme.size.static150};`
);
